import { useMemo } from 'react';

/**
 * Hook to create printer options for select dropdowns
 */
export const usePrinterOptions = (printers) => {
    return useMemo(() => {
        if (!printers || !Array.isArray(printers)) return [];
        return printers
            .filter(printer => printer.isActive)
            .map(printer => ({
                value: printer.id,
                label: printer.name
            }));
    }, [printers]);
};

/**
 * Hook to create Shopify category options for select dropdowns
 */
export const useCategoryOptions = (categories) => {
    return useMemo(() => {
        if (!categories || !Array.isArray(categories)) return [];
        return categories
            .filter(category => category.isActive)
            .map(category => ({
                value: category.id,
                label: category.name
            }));
    }, [categories]);
};

/**
 * Hook to create user options for select dropdowns (supporters)
 */
export const useUserOptions = (users) => {
    return useMemo(() => {
        if (!users || !Array.isArray(users)) return [];
        return users
            .filter(user => user.active !== false && (user.role === 'Support' || user.role === 'Manager'))
            .map(user => ({
                value: user.id,
                label: user.username || user.fullName
            }));
    }, [users]);
};
